import * as React from 'react'

function SvgCheckIcon(props) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 60 60"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M28.5009 30L16 17.4991L17.4991 16L30 28.5009L42.5009 16L44 17.4991L31.4991 30L44 42.5009L42.5009 44L30 31.4991L17.4991 44L16 42.5009L28.5009 30Z" />
    </svg>
  )
}

export default SvgCheckIcon
